export default {
  badge: 'Знак',
  open: 'Открыть',
  close: 'Закрыть',
  dismiss: 'Отклонить',
  confirmEdit: {
    ok: 'ОК',
    cancel: 'Отмена',
  },
  dataIterator: {
    noResultsText: 'Не найдено подходящих записей',
    loadingText: 'Запись загружается...',
  },
  dataTable: {
    itemsPerPageText: 'Строк на странице:',
    ariaLabel: {
      sortDescending: 'Упорядочено по убыванию.',
      sortAscending: 'Упорядочено по возрастанию.',
      sortNone: 'Не упорядочено.',
      activateNone: 'Активируйте, чтобы убрать сортировку.',
      activateDescending: 'Активируйте для упорядочивания убыванию.',
      activateAscending: 'Активируйте для упорядочивания по возрастанию.',
      selectRow: 'Выбрать строку',
      selectAll: 'Выбрать всё',
      selectGroup: 'Выбрать группу',
    },
    sortBy: 'Сортировать по',
  },
  dataFooter: {
    itemsPerPageText: 'Записей на странице:',
    itemsPerPageAll: 'Все',
    nextPage: 'Следующая страница',
    prevPage: 'Предыдущая страница',
    firstPage: 'Первая страница',
    lastPage: 'Последняя страница',
    pageText: '{0}-{1} из {2}',
  },
  dateRangeInput: {
    divider: 'до',
  },
  datePicker: {
    itemsSelected: '{0} выбрано',
    range: {
      title: 'Выбранные даты',
      header: 'Ввод дат',
    },
    title: 'Выбор даты',
    header: 'Ввод даты',
    input: {
      placeholder: 'Введите дату',
    },
    ariaLabel: {
      previousMonth: 'Предыдущий месяц',
      nextMonth: 'Следующий месяц',
      selectYear: 'Выбрать год',
      previousYear: 'Предыдущий год',
      nextYear: 'Следующий год',
      selectMonth: 'Выбрать месяц',
      selectDate: '{0}',
      currentDate: 'Сегодня, {0}',
    },
  },
  noDataText: 'Отсутствуют данные',
  carousel: {
    prev: 'Предыдущий слайд',
    next: 'Следующий слайд',
    ariaLabel: {
      delimiter: 'Слайд {0} из {1}',
    },
  },
  calendar: {
    moreEvents: 'Еще {0}',
    today: 'Сегодня',
  },
  input: {
    clear: 'Очистить {0}',
    prependAction: '{0} предварительных действий',
    appendAction: '{0} добавочных действий',
    otp: 'Пожалуйста введите символы OTP {0}',
  },
  fileInput: {
    counter: 'Файлов: {0}',
    counterSize: 'Файлов: {0} (всего {1})',
  },
  fileUpload: {
    title: 'Перетащите файлы сюда',
    divider: 'или',
    browse: 'Просмотр файлов',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Выберите время',
    hour: 'Час',
    minute: 'Минуты',
    second: 'Секунды',
    notAllowed: 'Значение не разрешено',
  },
  pagination: {
    ariaLabel: {
      root: 'Навигация по страницам',
      next: 'Следующая страница',
      previous: 'Предыдущая страница',
      page: 'Перейти на страницу {0}',
      currentPage: 'Текущая страница, Страница {0}',
      first: 'Первая страница',
      last: 'Последняя страница',
    },
  },
  stepper: {
    next: 'Следующий',
    prev: 'Предыдущий',
  },
  rating: {
    ariaLabel: {
      item: 'Рейтинг {0} из {1}',
    },
  },
  loading: 'Загрузка...',
  infiniteScroll: {
    loadMore: 'Загрузить ещё',
    empty: 'Больше нечего загружать',
  },
  rules: {
    required: 'Это поле обязательно',
    email: 'Пожалуйста, введите действительный email',
    number: 'Это поле может содержать только цифры',
    integer: 'Это поле может содержать только целые числа',
    capital: 'Это поле может содержать только заглавные буквы',
    maxLength: 'Вы должны ввести не более {0} символов',
    minLength: 'Вы должны ввести не менее {0} символов',
    strictLength: 'Длина введенного поля недействительна',
    exclude: 'Символ {0} не разрешен',
    notEmpty: 'Пожалуйста, выберите хотя бы одно значение',
    pattern: 'Недопустимый формат',
  },
  command: {
    search: 'Введите команду или введите...',
  },
  hotkey: {
    then: 'затем',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Стрелка вверх',
    downArrow: 'Стрелка вниз',
    leftArrow: 'Стрелка влево',
    rightArrow: 'Стрелка вправо',
    backspace: 'Backspace',
    space: 'Пробел',
    plus: 'плюс',
    shortcut: 'Сочетание клавиш: {0}',
    or: 'или',
  },
  video: {
    play: 'Воспроизвести',
    pause: 'Пауза',
    seek: 'Перемотка',
    volume: 'Громкость',
    showVolume: 'Показать регулятор громкости',
    mute: 'Отключить звук',
    unmute: 'Включить звук',
    enterFullscreen: 'Полноэкранный режим',
    exitFullscreen: 'Выйти из полноэкранного режима',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Выбрать цвет с экрана',
      hueSlider: 'Оттенок',
      alphaSlider: 'Прозрачность',
      redInput: 'Красный',
      greenInput: 'Зеленый',
      blueInput: 'Синий',
      alphaInput: 'Прозрачность',
      hueInput: 'Оттенок',
      saturationInput: 'Насыщенность',
      lightnessInput: 'Яркость',
      hexInput: 'Значение HEX',
      hexaInput: 'Значение HEX с прозрачностью',
      changeFormat: 'Изменить формат цвета',
    },
  },
}
